import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/aviso-legal/page.tsx");
